import React, { useState } from 'react';
import CardActualizacionMasiva from '../../../General/Excel/CardActualizacionMasiva';
import { putExcelPublicacionesTipoYEnvioApi } from '../../../../api/axios';
import { formatFile } from '../../../../utilities/formatFile';
import { toast } from 'react-toastify';

export default function ActualizacionMasivaTipoYEnvio() {
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const isValidUpdateExcel = () => {
    if (!file) {
      toast.warn('No se ha seleccionado ningún archivo excel');
      return false;
    }
    return true;
  }

  const exportExcel = async () => {
    setIsLoading(true);

    let excelBase64 = await formatFile(file, "xlsx");
    let response = putExcelPublicacionesTipoYEnvioApi({ file: excelBase64 });

    response.then(res => {
      toast.success("Las publicaciones se actualizaron correctamente.")
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.warn(error))
        : toast.error("Las publicaciones no pudieron ser actualizadas");
    }).finally(() => {
      setIsLoading(false);
    });
  }

  // const excelTemplate = {
  //   fileResultName: "Modelo Actualización TipoPub-Envio",
  //   sheetName: "Publicaciones",
  //   columns: [{ CodProducto: "---", IdTipopublicacion: "0", Envio: "0" }]
  // };


  return (
    <div className="card p-4">
      <CardActualizacionMasiva
        title="Tipo Publicacion y Envío"
        btnText="Actualizar Tipo Publicacion y Envío"
        //dataSet={excelTemplate}
        isLoading={isLoading}
        updateFile={setFile}
        exportExcel={exportExcel}
        isValidUpdateExcel={isValidUpdateExcel}
        tipoExcel={3}
        downloadName="Modelo Actualización TipoPub-Envio"
      />
    </div>
  )
}